import React, { useState } from 'react';
import { View, TouchableHighlight, Platform, ActivityIndicator, Alert, TouchableOpacity } from 'react-native';
import { Image, Text, Icon } from '@components';
import { BaseColor } from '@config';
import styles from './styles';
import { connect, useDispatch } from 'react-redux';

import { Skeleton } from 'moti/skeleton';
import { MotiView } from 'moti';
import Menu from '../../components/Menu';
import { TextInput } from 'react-native-gesture-handler';
import { deletePosition } from '../../helpers';

const authorisations = [
    {
        type: 'AA',
        id: 1,
        description: "Zugriff auf allen Aktionen"
    },
    {
        type: 'ZA',
        value: 2,
        description: "Zugriff auf zugew. Aktionen"
    },
    {
        type: 'ZM',
        value: 3,
        description: "Zugriff auf zugew. Märkte"
    },
];

function SinglePosition(props) {
    const { position, client, key, loading, style, navigation, onPositionDeleted, onPositionEdited, userId } = props;
    const [editing, setEditing] = useState(false);
        
    const deletePositionAlert = (id) => {
        Alert.alert({
            title: position.title + ' löschen',
            message: 'Achtung!\nWenn diese Position gelöscht wird, dann werden alle Benutzer mit dieser Position aus allen zugewiesenen Aktionen und Märkten entfernt.',
            type: 'error',
            action: [
                { text: 'Löschen', onPress: () =>{ deletePosition({id}); onPositionDeleted(id)} },
                { text: 'Abbrechen', onPress: () => { } },
            ],
        });
    };

    const renderGrid = () => {
        if (loading) {
            return (
                <View key={key} style={[styles.default, style, { overflow: 'hidden' }]}>
                    <MotiView
                        transition={{
                            type: 'timing',
                        }}
                        style={{ backgroundColor: '#ffffff' }}
                        animate={{ backgroundColor: '#ffffff' }}

                    >
                        <Skeleton radius={3} height={100} width={"100%"} colorMode='light' colors={["#eee", "#efefef", "#fff", "#eee", "#efefef", "#fff", "#eee", "#efefef", "#fff"]} />
                    </MotiView>
                </View>
            );
        }
        return (
          
            <View 
                                        style={{
                                            padding: 10,
                                            borderBottomWidth: 1,
                                            borderBottomColor: BaseColor.grayLight,
                                            opacity: 1,
                                        }}
                                        key={key}
                                    >
                                      <View style={{ flexDirection: 'row' }}>
                                            <View
                                                style={{
                                                    marginRight: 10,
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        backgroundColor: BaseColor.grayLight,
                                                        height: 40,
                                                        width: 40,
                                                        borderRadius: 15,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Icon name="idcard" type="ad" size={18} color={BaseColor.text} />
                                                </View>
                                            </View>

                                            <View style={{ justifyContent: 'center', flex: 1 }}>
                                                <Text callout1>{`${position.title} (${position.abbreviation})`}</Text>
                                                {position.description&&<Text footnote grayColor>{`${position.description}`}</Text>}
                                               <View style={{flexDirection:'row', justifyContent:'space-between'}}>
                                                
                                                {/* <View style={{flexDirection:'row', alignItems:'center'}}>{position.authorisations?.map(authorisation=><View style={{justifyContent:'center', alignItems:'center', paddingHorizontal:5, height:20, borderRadius:3, marginRight:3, backgroundColor:BaseColor.grayLight1}}><Text caption2>{authorisation.type}</Text></View>)}</View>    */}
                                                <View style={{flexDirection:'row', alignItems:'center'}}><View style={{justifyContent:'center', alignItems:'center', paddingHorizontal:5, height:20, borderRadius:3, marginRight:3, backgroundColor:"#f0f0ff"}}><Text caption2>{authorisations.find(auth=>auth.type==position.access).description}</Text></View></View>   
                                                <View
                                                style={{
                                                    flexDirection:'row',
                                                }}
                                            >
                                                <TouchableOpacity
                                                    style={{
                                                        height: 30,
                                                        width: 30,
                                                        borderRadius: 15,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                    onPress={()=>navigation.navigate("AssignUserToPosition", {position, onPositionEdited})}
                                                >
                                                   
                                                        <Icon
                                                            name="addusergroup"
                                                            type="ad"
                                                            size={20}

                                                        />
                                                        <View style={{position:'absolute', bottom:-3, right:-3}}  ><Text primaryColor caption1 bold>{position.users?.length??0}</Text></View>
                                                    
                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    style={{
                                                        height: 30,
                                                        width: 30,
                                                        borderRadius: 15,marginLeft:15,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                    onPress={()=>navigation.navigate("EditPosition", {position, onPositionEdited})}
                                                >
                                                   
                                                        <Icon
                                                            name="edit"
                                                            type="ad"
                                                            size={20}

                                                        />
                                                    
                                                </TouchableOpacity>
                                                <TouchableOpacity
                                                    style={{
                                                        height: 30,
                                                        width: 30,
                                                        borderRadius: 15,
                                                        marginLeft:15,
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                    }}
                                                    onPress={()=>deletePositionAlert(position.id)}
                                                >
                                                   
                                                        <Icon
                                                            name="delete"
                                                            type="ad"
                                                            size={20}
                                                        />
                                                    
                                                </TouchableOpacity>
                                            </View> 
                                            </View></View>
                                           
                                        </View>
                                    </View>
        
    );
    };

    return renderGrid();
}

function mapState(state) {
    const { user } = state.users;
    const { device } = state.offlineStorage;
    return { role: user?.roles[0], userId: user.id, device };
}

const actionCreators = {
};

export default connect(mapState, actionCreators)(SinglePosition);
